module.exports = __webpack_public_path__ + "static/img/application5-4.de2ebf3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/application/application5/application5-4.jpg
// module id = iFrs
// module chunks = 0